module.exports = __webpack_public_path__ + "static/media/TorontoPolice.b5aa6f7f.png";